
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaStop as ObiMediaStopElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-stop.js';
 
 
 

 
 export const ObiMediaStop = createComponent({
   react: React,
   tagName: 'obi-media-stop',
   elementClass: ObiMediaStopElement,
   events: {
     
   }
  });
 
 